/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Manage_ProductsInputs */

const en_admin_resource_form_manage_products = /** @type {(inputs: Admin_Resource_Form_Manage_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage »`)
};

const de_admin_resource_form_manage_products = /** @type {(inputs: Admin_Resource_Form_Manage_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten »`)
};

const es_admin_resource_form_manage_products = /** @type {(inputs: Admin_Resource_Form_Manage_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar »`)
};

const fr_admin_resource_form_manage_products = /** @type {(inputs: Admin_Resource_Form_Manage_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer »`)
};

const nl_admin_resource_form_manage_products = /** @type {(inputs: Admin_Resource_Form_Manage_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheren »`)
};

/** @type {(inputs: Admin_Resource_Form_Manage_ProductsInputs) => LocalizedString} */
const it_admin_resource_form_manage_products = en_admin_resource_form_manage_products;

/** @type {(inputs: Admin_Resource_Form_Manage_ProductsInputs) => LocalizedString} */
const pt_br2_admin_resource_form_manage_products = en_admin_resource_form_manage_products;

/** @type {(inputs: Admin_Resource_Form_Manage_ProductsInputs) => LocalizedString} */
const pl_admin_resource_form_manage_products = en_admin_resource_form_manage_products;

/** @type {(inputs: Admin_Resource_Form_Manage_ProductsInputs) => LocalizedString} */
const hu_admin_resource_form_manage_products = en_admin_resource_form_manage_products;

/** @type {(inputs: Admin_Resource_Form_Manage_ProductsInputs) => LocalizedString} */
const ro_admin_resource_form_manage_products = en_admin_resource_form_manage_products;

/**
* | output |
* | --- |
* | "Manage »" |
*
* @param {Admin_Resource_Form_Manage_ProductsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_manage_products = /** @type {((inputs?: Admin_Resource_Form_Manage_ProductsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Manage_ProductsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_manage_products(inputs)
	if (locale === "de") return de_admin_resource_form_manage_products(inputs)
	if (locale === "es") return es_admin_resource_form_manage_products(inputs)
	if (locale === "fr") return fr_admin_resource_form_manage_products(inputs)
	if (locale === "nl") return nl_admin_resource_form_manage_products(inputs)
	if (locale === "it") return it_admin_resource_form_manage_products(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_manage_products(inputs)
	if (locale === "pl") return pl_admin_resource_form_manage_products(inputs)
	if (locale === "hu") return hu_admin_resource_form_manage_products(inputs)
	return ro_admin_resource_form_manage_products(inputs)
});
export { admin_resource_form_manage_products as "admin.resource_form.manage_products" }